/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow_right': {
    width: 16,
    height: 16,
    viewBox: '0 0 256 256',
    data: '<path pid="0" d="M83.9 254.2l126.5-126.4L83.9 1.3 46 39.3l88.4 88.5L46 216.2z"/>'
  }
})
